(function () {
    'use strict';

    var module = angular.module('uwAgenda.search');
    module.controller('SearchController', [
        '$scope',
        '$stateParams',
        '$sanitize',
        'SearchService',
        'SharedAgendaService',
        'HelperService',
        'Daytask',
        'UserSearchPaginationService',
        'PaginationService',
        SearchControllerFn]);

    /* controlle for search */
    function SearchControllerFn(
        $scope,
        $stateParams,
        $sanitize,
        SearchService,
        SharedAgendaService,
        HelperService,
        Daytask,
        UserSearchPaginationService,
        PaginationService) {
        var vm = this;

        // search string
        vm.searchStr = '';
        // collapse
        vm.collapse = function (agenda) {
            agenda.collapsed = !agenda.collapsed;
        };
        activate();

        // search 
        function doSearch(searchValue) {
           
            // is there something to search for ?
            if (!searchValue || searchValue.length === 0) {
                return;
            }

            // set current userId
            let userId = SharedAgendaService.currentUser().id;
            let agendaId = SharedAgendaService.data.currentAgenda.id;
            
            SearchService.searchAppointments(userId, agendaId, searchValue).then(function (result) {
                vm.searchResults.totalAppointments = setAppointmentsTodaySeparatorAndReturnTotal(result.agendaWithAppointments);
                addAppointmentSearchResultsToDisplayedAgendas(result.agendaWithAppointments);
            });
            
            SearchService.searchTasks(userId, agendaId, searchValue).then(function (result) {
                let totalNumberOfTasks = 0;
                
                // map results to daytasks
                result.data.agendaWithTasks.forEach(function (agendaWithTasks) {
                    totalNumberOfTasks += agendaWithTasks.tasks.length;
                    // map each task to daytask for layout
                    agendaWithTasks.tasks.forEach(function (task) {
                        let dayTask = new Daytask();
                        dayTask.extend(task);
                        task.dayTask = dayTask;
                    });
                });                
                vm.searchResults.totalTasks = totalNumberOfTasks;
                addTaskSearchResultsToDisplayedAgendas(result.data.agendaWithTasks);
            });
        }
        
        function clearExistingSearchResults()
        {
            if (vm.searchResults)
            {
                // reset existing references
                vm.searchResults.agendasWithResults.forEach(function (agendaWithResults){
                    agendaWithResults.collapsed = false;
                    agendaWithResults.appointmentsPaginationService = undefined;
                    agendaWithResults.tasksPaginationService = undefined;
                });
            }
            
            // reset items
            vm.searchResults = {
                agendasWithResults: [],
                errorMessage: '',
                totalTasks: '...',
                totalAppointments: '...'
            };
        }
        
        function addAppointmentSearchResultsToDisplayedAgendas(agendasWithAppointments)
        {
            //let orderedAgendaIds =  returnOrderedAndMergedAgendaIdList(agendasWithAppointments.map(a => a.id));
            agendasWithAppointments.forEach(function(agendaWithAppointments){
                // if agenda is already in list, just add the appointments
                let agendaWithResults = vm.searchResults.agendasWithResults.find(agendaWithResults => agendaWithResults.id === agendaWithAppointments.id)
                if(agendaWithResults)
                {
                    agendaWithResults.appointmentsPaginationService = new PaginationService(agendaWithAppointments.appointments);
                }else{
                    let sharedAgendaFilterResult = SharedAgendaService.data.agendas.find(a => a.id === agendaWithAppointments.id);
                    if (sharedAgendaFilterResult){
                        sharedAgendaFilterResult.appointmentsPaginationService = new PaginationService(agendaWithAppointments.appointments);
                        vm.searchResults.agendasWithResults.push(sharedAgendaFilterResult);
                    }
                }
            });
            // current agenda always on top of results
            vm.searchResults.agendasWithResults.sort(sortAgendas);
        }

        function addTaskSearchResultsToDisplayedAgendas(agendasWithTask)
        {
            agendasWithTask.forEach(function(agendaWithTask){
                // if agenda is already in list, just add the appointments
                let agendaWithResults = vm.searchResults.agendasWithResults.find(agendaWithResults => agendaWithResults.id === agendaWithTask.agendaId)
                if(agendaWithResults)
                {
                    agendaWithResults.tasksPaginationService = new PaginationService(agendaWithTask.tasks, 5);
                }else{
                    let sharedAgendaFilterResult = SharedAgendaService.data.agendas.find(a => a.id === agendaWithTask.agendaId);
                    if (sharedAgendaFilterResult){
                        sharedAgendaFilterResult.tasksPaginationService = new PaginationService(agendaWithTask.tasks, 5);
                        vm.searchResults.agendasWithResults.push(sharedAgendaFilterResult);
                    }
                }
            });
            // current agenda always on top of results
            vm.searchResults.agendasWithResults.sort(sortAgendas);
        }
        
        function sortAgendas(previousAgenda, nextAgenda)
        {
            return previousAgenda.id === SharedAgendaService.data.currentAgenda.id ? -1 : nextAgenda.id === SharedAgendaService.data.currentAgenda.id ? 1 : 0;
        }

        

        function setAppointmentsTodaySeparatorAndReturnTotal(appointmentsPerAgenda) {
            // indicate where past-future (today) separator must be shown (for all agendas)
            var prevAppInTheFuture = false;
            var today = moment();
            var totalNumberOfAppointments = 0;
            for (var agenda of appointmentsPerAgenda) {
                agenda.appointmentsPaginationService = new PaginationService(agenda.appointments);
                prevAppInTheFuture = false;
                totalNumberOfAppointments += agenda.appointments.length ;
                for (let app of agenda.appointments) {
                    // detect appointment in the past
                    if (moment(app.appointmentDate).isAfter(today)) {
                        prevAppInTheFuture = true;
                    }

                    // detect appointment in the future
                    if (moment(app.appointmentDate).isBefore(today) &&
                        prevAppInTheFuture) {
                        app.showTodaySeparator = true;
                        break;
                    }
                }
            }
            return totalNumberOfAppointments;
        }

        // activate
        function activate() {
            $scope.$on("$destroy", function () {
                clearExistingSearchResults();
            });
            
            // set searchstr
            vm.searchStr = $stateParams.searchStr;
            clearExistingSearchResults();
            vm.searchResults.errorMessage= $stateParams.errorMessage;

            var today = moment(new Date());
            var todayCaption = today.format('dddd') + ', ' + today.format('LL');
            vm.currentDateCaption = todayCaption;

            if (!vm.searchResults.errorMessage) {
                // check searchstr
                doSearch(vm.searchStr);
            }
        }
    }
})();
